import { render, staticRenderFns } from "./createdAt.vue?vue&type=template&id=7cfcaa56&"
import script from "./createdAt.vue?vue&type=script&lang=js&"
export * from "./createdAt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports